import {
  Button,
  Form,
  Input,
  InputNumber,
  Modal,
  notification,
  Space,
  Spin,
} from "antd";
import React from "react";
import api from "../../URL/axiosConfig";

const ModalSetPulse = ({ open, setOpen, devEui, getData }) => {
  const [loading, setLoading] = React.useState(false);
  const [data, setData] = React.useState({});
  const [form] = Form.useForm();

  const onFinish = values => {
    console.log("Success:", values);
    setLoading(true);
    api({
      url: `/action/pulse/cms/${values.DevEui}/${values.Pulse}/${values["Pulse Count"]}`,
      method: "POST",
    })
      .then(ok => {
        setLoading(false);
        getData();
        setOpen(false);
        // alert("Success Set Interval");
        notification.success({
          message: "Success set Pulse",
          placement: "bottomRight",
        });
      })
      .catch(err => {
        // alert(err.response.data.message);
        notification.success({
          message: err.response.data.message,
          placement: "bottomRight",
        });
        setLoading(false);
      });
  };

  React.useEffect(() => {
    console.log(devEui, "DEVEUI");
    if (open) {
      form.setFields([
        {
          name: "DevEui",
          value: devEui,
        },
      ]);
    } else {
      form.resetFields();
    }
  }, [open, devEui]);

  return (
    <Modal
      cancelButtonProps={{
        // size: "large",
        style: {
          display: "none",
        },
      }}
      visible={open}
      onCancel={() => setOpen(false)}
      okButtonProps={{ style: { display: "none" } }}
      title="Set UTC"
    >
      <Spin spinning={loading}>
        <Form
          form={form}
          name="setutc"
          labelCol={{
            span: 8,
          }}
          wrapperCol={{
            span: 16,
          }}
          onFinish={onFinish}
          autoComplete="off"
        >
          <Form.Item label="DevEui" name="DevEui">
            <Input disabled />
          </Form.Item>
          <Form.Item
            label="Pulse"
            name="Pulse"
            rules={[
              {
                required: true,
                message: "Please input your Pulse!",
              },
            ]}
          >
            <InputNumber />
          </Form.Item>
          <Form.Item
            label="Pulse Count"
            name="Pulse Count"
            rules={[
              {
                required: true,
                message: "Please input your Pulse Count!",
              },
            ]}
          >
            <InputNumber />
          </Form.Item>

          <Form.Item
            wrapperCol={{
              offset: 8,
              span: 16,
            }}
          >
            <Space>
              <Button onClick={() => setOpen(false)}>Cancel</Button>
              <Button type="primary" htmlType="submit">
                Submit
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Spin>
    </Modal>
  );
};

export default ModalSetPulse;
